import React from 'react';
import { Link } from 'react-router-dom';
import PublicLayout, { PageHero } from '../../components/PublicLayout';
import { Button } from '../../components/ui/button';
import { Car, Home, HeartPulse, ShieldCheck, ArrowRight, Check } from 'lucide-react';
import { useLanguage } from '../../lib/LanguageContext';

const items = [
  { id: 'auto', icon: Car, name: 'Assurance auto', tagline: 'Tarifs négociés', desc: 'Au tiers, intermédiaire ou tous risques : trouvez la formule qui vous convient.', bullets: ['Tous risques dès 19 €/mois', 'Assistance 24/7', 'Véhicule de remplacement', 'Bris de glace'] },
  { id: 'habitation', icon: Home, name: 'Assurance habitation', tagline: 'Capital protégé', desc: 'Locataire ou propriétaire, protégez votre logement et vos biens.', bullets: ['Multirisques habitation', 'Vol et dégats des eaux', 'Responsabilité civile', 'Dépannage urgences'] },
  { id: 'vie', icon: ShieldCheck, name: 'Assurance vie', tagline: 'Préparez l’avenir', desc: 'Constituez et transmettez un capital dans un cadre fiscal avantageux.', bullets: ['Fonds en euros + UC', 'Frais de gestion 0,60%', 'Versements libres', 'Donateur désignable'] },
  { id: 'sante', icon: HeartPulse, name: 'Complémentaire santé', tagline: 'Sans questionnaire', desc: 'Complétez le remboursement Sécu pour vous et votre famille.', bullets: ['Tiers payant', 'Hospitalisation 100%', 'Optique & dentaire', 'Médecines douces'] },
];

export default function Assurances() {
  const { t } = useLanguage();
  return (
    <PublicLayout>
      <PageHero eyebrow={t('public.assurancesEyebrow')} title={t('public.assurancesTitle')} subtitle={t('public.assurancesSubtitle')}>
        <Link to="/inscription"><Button size="lg" className="bg-white text-blue-900 hover:bg-slate-100">{t('public.requestQuote')} <ArrowRight className="ml-2 w-4 h-4"/></Button></Link>
      </PageHero>
      <section className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-6">
        {items.map((c) => (
          <div key={c.id} id={c.id} className="p-6 md:p-8 rounded-2xl border border-slate-200 bg-white hover:shadow-lg transition">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-blue-50 text-blue-700 flex items-center justify-center"><c.icon className="w-6 h-6"/></div>
              <div>
                <div className="text-xs text-blue-700 font-semibold uppercase">{c.tagline}</div>
                <h2 className="font-bold text-xl text-slate-900">{c.name}</h2>
              </div>
            </div>
            <p className="text-slate-600 mt-3">{c.desc}</p>
            <ul className="mt-4 space-y-2 text-sm">
              {c.bullets.map((b, i) => <li key={i} className="flex items-start gap-2"><Check className="w-4 h-4 text-emerald-600 mt-0.5"/> {b}</li>)}
            </ul>
          </div>
        ))}
      </section>
    </PublicLayout>
  );
}
